import {
  Header,
  ContentBlockCard,
  Section,
  TheFork,
} from '@components';
import { AddRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

export default function Stores({
  title,
  description,
  label,
  list,
}) {
  const { locale } = useRouter();
  const { t } = useTranslation();
  const slugs =
    locale === 'it'
      ? [
          'villa-mon-repos',
          'ristorante-momento-neapolis',
          'caffetteria-belvedere-taormina',
          'caffetteria-momento-neapolis',
          'ristorante-degli-scavi',
        ]
      : [
          'villa-mon-repos',
          'ristorante-momento-neapolis',
          'caffetteria-belvedere-taormina',
          'caffetteria-momento-neapolis',
          'scavi-restaurant',
        ];
  const sortedList = list
    ? [...list].sort((a, b) => {
        const aSlug = a?.attributes?.slug;
        const bSlug = b?.attributes?.slug;
        return slugs.indexOf(aSlug) - slugs.indexOf(bSlug);
      })
    : [];
  return (
    <Section id="stores">
      <Header
        title={title}
        label={label}
        description={description}
      />
      <div className="space-y-16">
        {sortedList?.length > 0 &&
          sortedList?.map((item, i) => {
            const {
              hero,
              name,
              address,
              location,
              slug,
              city,
              category,
              the_fork_button,
            } = item?.attributes;
            const { name: location_name, short_description } =
              location?.data?.attributes ??
              city?.data?.attributes ??
              {};

            const categoryName = category?.data?.attributes?.name;

            const img = hero?.media?.data;
            return (
              <ContentBlockCard
                key={item?.id}
                img={img?.length > 1 ? img : img?.[0]?.attributes}
                index={i}
              >
                <p className="h2 text-primary">{name}</p>
                <div>
                  <p className="label">{location_name}</p>
                  <p className="address">{address}</p>
                </div>
                <p className="body max-w-[90%]">
                  {short_description || hero?.description}
                </p>
                <div className="flex flex-col justify-center items-center space-y-1">
                  {the_fork_button && (
                    <TheFork link={the_fork_button} />
                  )}
                  <Button href={`/stores/${categoryName}/${slug}`}>
                    <AddRounded className="mr-1" />{' '}
                    <span>{t('buttons.discover')}</span>
                  </Button>
                </div>
              </ContentBlockCard>
            );
          })}
      </div>
    </Section>
  );
}
